<template>
  <div
    ref="groups"
    :class="['groups', {'has_scroller': scroller}]"
    data-qa="groups">
    <div
      v-if="(group_view && group_view_variants) || grouped_by"
      class="groups-options flex flex-right">
      <SelectColumns
        v-if="group_view && group_view_variants"
        :name="group_view_name || $t('Common.Columns')"
        :value.sync="group_view_sync"
        :variants="group_view_variants"/>
      <GroupMenu
        v-if="grouped_by"
        :current.sync="grouped_by_sync"
        :types="groupedBy_types"/>
    </div>
    <div
      v-for="(group, groupIndex) in filtred_groups"
      :key="(group[groupKey] || groupIndex)+'_'+groupIndex"
      class="group"
      :data-qa="`group-${groupIndex}-${group.title || 'non-titled'}`">
      <div
        v-if="with_title"
        class="pl-1 pr-4 pointer text-start flex"
        :class="{'py-3': !small, 'pt-2': small}"
        :data-qa="`group-${groupIndex}-info`"
        @click="expandRow(group, true)">
        <div
          class="bold"
          :data-qa="`group-${groupIndex}-title`">
          <slot
            :group="group"
            :index="groupIndex"
            name="title">
            {{ group.title }}
          </slot>
        </div>
        <slot
          v-if="can_expand"
          :group="group"
          :index="groupIndex"
          name="score"/>
        <div class="spacer"/>
        <slot
          :group="group"
          :index="groupIndex"
          name="after"/>
        <div
          v-if="can_expand"
          :data-qa="`group-${groupIndex}-opened-chevron`">
          <sIcon
            class="ml-2 my-auto group-opened-chevron"
            :flip="expanded.some(el => el[groupKey] == group[groupKey]) ? 'vertical' : ''"
            size="10"
            type="arrow"/>
        </div>
        <slot
          v-else
          :group="group"
          :index="groupIndex"
          name="score"/>
      </div>
      <sDivider
        v-if="with_title && !small"
        color="var(--white-color)"/>
      <div
        v-if="!can_expand || expanded.some(el => el[groupKey] == group[groupKey])"
        :key="groupLinkFunc(group, groupIndex, filtred_groups)"
        ref="group_content"
        class="main__green px-0 group-content"
        :class="group_content_class"
        :data-qa="`group-${groupIndex}-content`">
        <slot
          ref="group_content_slot"
          :group="group"
          :index="groupIndex"
          name="content"/>
      </div>
    </div>
    <div
      v-if="scroller && !hide_scroller"
      ref="scroll_wrap"
      class="scroll-wrapper main__green d-flex align-center">
      <div
        ref="scroller"
        class="horizontal_scroller"
        @scroll="updateTableScroll">
        <div
          ref="scroll_in"
          class="scroller-in"/>
      </div>
    </div>
  </div>
</template>
<script>
import GroupMenu from 'components/common/blocks/groups/GroupMenu.vue'
import SelectColumns from 'components/common/blocks/groups/SelectColumns.vue'
/* eslint-disable vue/prop-name-casing */

export default {
  name: 'groups',
  data() {
    return {
      expanded: [],
      observer: null,
      observer_target: null,
      hide_scroller: true
    }
  },
  props: {
    /*
      чи показувати хедер з назвою
    */
    with_title: Boolean,
    /*
      групи
    */
    groups: {
      type: Array,
      default: () => []
    },
    groupKey: {
      type: String,
      default: 'id'
    },
    /*
      ключ таблиці, функція для того шоб привязуватись до самої групи
    */
    groupLinkFunc: {
      type: Function,
      default: (group, index) => (group.id || index) + '-content'
    },
    /*
      ключ списку
    */
    itemsKey: {
      type: String,
      default: 'items'
    },
    /*
      чи можна розкривати/приховувати групу по кліку на хедер

      !! потрібні ід в групах
    */
    can_expand: Boolean,
    /*
      чи показуваьт групу без списку
      !! потрібен filterEmptyBy || itemsKey
    */
    filter_empty: Boolean,
    /*
      функція перевірки чи показуваьт групу
    */
    filterEmptyBy: Function,
    content_class: {
      type: String,
      default: ''
    },
    /*
      функція для відстежування змін груп
    */
    watchChangedGroups: Function,
    /**
     * групування за
     */
    grouped_by: {
      type: Object
    },
    /**
     * типи групування
     * використовується тільки з grouped_by
     */
    groupedBy_types: {
      type: Array
    },
    /**
     * вигляд групи - для вибору колонок
     */
    group_view: {
      type: Array
    },
    /**
     * хедери - для вибору колонок
     * використовується тільки з group_view
     */
    group_view_variants: {
      type: Array
    },
    /**
     * назва меню вибору колонок
     * використовується тільки з group_view
     */
    group_view_name: {
      type: String
    },
    /**
     * чи показувати загальний скрол
     */
    scroller: {
      type: Boolean,
      default: false
    },
    /**
     * елемент scroller'а
     */
    scroller_ellement: {
      type: String,
      default: '.v-data-table__wrapper table'
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  beforeDestroy() {
    if ( this.observer ) {
      if ( this.observer_target ) {
        this.observer.unobserve(this.observer_target)
      }
      this.observer.unobserve(document.body)
    }
  },
  computed: {
    filtred_groups() {
      if ( this.filter_empty && this.itemsKey ) {
        let filter_func =  this.filterEmptyBy || (gr => gr[this.itemsKey]?.length || (this.can_expand && !this.$_.some(this.expanded, el => el[this.groupKey] == gr[this.groupKey])))
        return this.$_.filter(this.groups, filter_func)
      } else {
        return this.groups
      }
    },
    grouped_by_sync: {
      get() {
        return this.grouped_by
      },
      set(value) {
        this.$emit('update:grouped_by', value)
      }
    },
    group_view_sync: {
      get() {
        return this.group_view
      },
      set(value) {
        this.$emit('update:group_view', value)
      }
    },
    tables() {
      return this.$el?.querySelectorAll(this.scroller_ellement)
    },
    group_content_class() {
      if ( this.content_class ) {
        return this.content_class
      } else if ( this.with_title ) {
        return 'pt-6'
      }
      return ''
    }
  },
  methods: {
    expandRow(group) {
      if ( this.can_expand ) {
        let ind = this.expanded.findIndex(el => el[this.groupKey] == group[this.groupKey])
        if (ind < 0) {
          this.expanded.push(group)
          this.$emit('update:expanded', this.expanded, group, true)
        } else {
          this.expanded.splice(ind, 1)
          this.$emit('update:expanded', this.expanded, group)
        }
      }
    },
    expandAll(old) {
      if ( this.can_expand ) {
        if ( this.watchChangedGroups ) {
          this.expanded = this.watchChangedGroups(old, this.groups, this.expanded) || this.$_.cloneDeep(this.groups)
        } else {
          this.expanded = this.$_.cloneDeep(this.groups)
        }
      }
    },
    getTables() {
      return this.$el?.querySelectorAll(this.scroller_ellement)
    },
    updateTableScroll() {
      if ( !this.scroller || this.hide_scroller) { return }

      let tables = this.getTables(),
        scroller = this.$refs.scroller

      if ( !scroller ) { return }

      tables.forEach( table => table.parentElement.scrollLeft = scroller.scrollLeft )
    },
    updateScrollbar() {
      let groups = this.$refs?.groups,
        table = this.observer_target?.parentElement

      if ( !table ) { return }

      this.hide_scroller = table?.scrollWidth <= groups?.offsetWidth

      if ( this.hide_scroller ) { return }

      this.$nextTick(() => {

        let scroll_in = this.$refs.scroll_in,
          scroll_wrap = this.$refs?.scroll_wrap

        scroll_in.style.width = table?.scrollWidth + 'px'

        scroll_wrap.style.left = groups?.getBoundingClientRect()?.left + 'px'
        scroll_wrap.style.width = table.offsetWidth + 'px'
      })
    },
    updateObserver(upd_scroll) {
      if ( !this.scroller ) { return }

      if ( this.observer && !this.observer_target?.offsetHeight) {
        if ( this.observer_target ) {
          this.observer.unobserve(this.observer_target)
        }

        this.observer_target = this.$el.querySelector(this.scroller_ellement)
        if ( this.observer_target ) {
          this.observer.observe(this.observer_target)
        }
      }
      if ( upd_scroll ) {
        this.updateScrollbar()
      }
      this.$nextTick(() => {
        this.updateTableScroll()
      })
    }
  },
  watch: {
    groups: {
      handler(val, old) {
        this.expandAll(old)
      },
      immediate: true
    },
    expanded: {
      handler() {
        if ( !this.scroller ) { return }
        this.$nextTick(this.updateObserver)
      },
      immediate: true
    },
    scroller: {
      handler(val, old) {
        if ( val ) {
          this.observer = new ResizeObserver(this.updateScrollbar)
          this.observer.observe(document.body)
        } else if ( old && this.observer ) {
          if ( this.observer_target ) {
            this.observer.unobserve(this.observer_target)
          }
          this.observer.unobserve(document.body)
        }
      },
      immediate: true
    },
  },
  components: {
    GroupMenu,
    SelectColumns
  }
}
</script>
<style lang="scss" scoped>
.groups {
  position: relative;
  .scroll-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 24px;
    z-index: 200;
    .horizontal_scroller {
      cursor: pointer;
      height: 12px;
      overflow-x: auto;
      overflow-y: hidden;
      .scroller-in {
        height: 8px;
        visibility: hidden;
      }
    }
  }
}
</style>
<style lang="scss">
.groups.has_scroller {
  .v-data-table__wrapper {
    overflow-x: hidden !important;
  }
}
</style>
